module.exports = __webpack_public_path__ + "img/portrait_icon.ab80f661.png";